import { render, staticRenderFns } from "./CompanyFulfillmentsOmsIndex.vue?vue&type=template&id=01158f24&scoped=true&"
import script from "./CompanyFulfillmentsOmsIndex.vue?vue&type=script&lang=js&"
export * from "./CompanyFulfillmentsOmsIndex.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFulfillmentsOmsIndex.vue?vue&type=style&index=0&id=01158f24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01158f24",
  null
  
)

export default component.exports